import Container from './component/layout/Container';

function App() {
  return (
    <div className="App">
      <Container />
    </div>
  );
}

export default App;
